import React from 'react';

/** Shown when the root Sentry error boundary catches a render error. */
export function FriendlyErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Something went wrong</h1>
        <p className="text-gray-600 mb-6">
          Sorry about that. Please refresh the page and try again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-amber-700 text-white px-6 py-3 rounded-lg hover:bg-amber-800 transition font-medium"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}
